import type { SchemaField } from '@cli-types/core-engine/schema.js'

export function selectDefaultValues(f: SchemaField): string[] {
  if (f.default === undefined || f.default === null || f.default === '') return []
  const values = Array.isArray(f.default) ? f.default : [f.default]
  return values.map((value) => String(value))
}
